import { Component, h, Host, Prop, Element, Listen } from "@stencil/core";
import { contextPath } from "@globals/config";
import state, {
  getCompareEntryList,
  getComparisonData,
} from "@stores/product.comparison.store";

@Component({
  tag: "f-compare-flyout",
  shadow: true,
})
export class FCompareFlyout {
  @Element() el: HTMLFCompareFlyoutElement;

  /**
   * Labels enabling multilingualism
   */
  @Prop() buttonHiddenLabel = "Comparison";
  @Prop() buttonTitle = this.buttonHiddenLabel;
  @Prop() closeButtonHiddenLabel;
  @Prop() expanderButtonHiddenLabel = "";
  @Prop() totalNetPriceLabel = "Total net price";
  @Prop() openComparisonButtonLabel = "Open comparison";
  @Prop() addMoreProductsWarningLabel =
    "Please select at least 2 products to proceed to product comparison";
  @Prop() titleLabel = "My comparison";
  @Prop() quantityLabel = "quantity: ";
  @Prop() errorMessageLabel = "An Error Occurred";
  @Prop() emptyListLabel = "Comparison is empty";
  @Prop() numberOfShownProducts = 3;

  @Listen("productAddedToComparison", { target: "document" })
  async handleProductAddToComparison(): Promise<void> {
    await getComparisonData();
    this.flyoutEl.toggleFlyout();
  }

  async componentWillLoad(): Promise<void> {
    await getComparisonData();
  }

  private flyoutEl;

  render() {
    const flyoutTitle = `${this.titleLabel} (${state.currentProductsQuantity})`;
    const entries = getCompareEntryList();

    return (
      <Host data-test="mini-compare">
        <f-flyout-with-button
          flyoutTitle={flyoutTitle}
          flyoutId="f-compare-flyout"
          ref={(el) => (this.flyoutEl = el)}
          buttonIconName="compare"
          buttonBadgeLabel={state.currentProductsQuantity}
          buttonTitle={this.buttonTitle}
          closeButtonHiddenLabel={this.closeButtonHiddenLabel}
          flyoutDataTest="compare-flyout"
        >
          <f-visually-hidden>{this.buttonHiddenLabel}</f-visually-hidden>
          <div slot="flyout-content">
            {state.initialized && !state.loading && (
              <f-flyout-product-list
                entries={entries}
                quantityLabel={this.quantityLabel}
                openDetailsButtonLabel={this.openComparisonButtonLabel}
                priceLabel={this.totalNetPriceLabel}
                emptyListLabel={this.emptyListLabel}
                detailsUrl={
                  entries?.length >= 2
                    ? `${contextPath}products-comparison`
                    : ""
                }
                numberOfItems={this.numberOfShownProducts}
                expanderButtonHiddenLabel={this.expanderButtonHiddenLabel}
              />
            )}
            {state.loading && <f-flyout-loader />}
            {state.is === "ERROR" && state.errors.length > 0 && (
              <f-flyout-message messageLabel={this.errorMessageLabel} />
            )}
          </div>
          {/* empty div is necessary, because with the slot property on the f-flyout-footer, after removing a product a new slot would appear and that would cause an error */}
          <div slot="flyout-footer">
            {entries?.length < 2 && (
              <f-flyout-footer>
                <f-notification
                  slot="flyout-footer-content"
                  variant="warning"
                  with-icon="true"
                >
                  {this.addMoreProductsWarningLabel}
                </f-notification>
              </f-flyout-footer>
            )}
          </div>
        </f-flyout-with-button>
      </Host>
    );
  }
}
